import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 4l-2 2","key":"svg-0"}],["path",{"d":"M22 10.5l-2.5 -.5","key":"svg-1"}],["path",{"d":"M13.5 2l.5 2.5","key":"svg-2"}],["path",{"d":"M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2","key":"svg-3"}]]

const IconPhoneRinging = createReactComponent('outline', 'phone-ringing', 'PhoneRinging', __iconNode);

export default IconPhoneRinging;